import app from './config/configApp';
import appAxios from '@/utility/appAxios';
import router from './routes/protectedRoute';
import store from '@/vuex/store';
import './static/css/style.css';
import CKEditor from '@ckeditor/ckeditor5-vue';

// Vue 3rd party plugins
import '@/core/plugins/ant-design';
import '@/core/plugins/fonts';
import '@/core/plugins/maps';
import '@/core/plugins/masonry';
import '@/core/plugins/apexcharts';
import '@/core/components/custom';
import '@/core/components/style';
import i18n from './i18n';
import { endpoints } from '@/services/api';
import VueApexCharts from "vue3-apexcharts";

app.config.productionTip = false;
app.config.globalProperties.$appAxios = appAxios;
app.config.globalProperties.$endpoints = endpoints;
app.use(store);
app.use(router);
app.use(i18n);
app.use(VueApexCharts);
app.use(CKEditor);
app.mount('#app'); 